import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { StyledSmallText, StyledSuccessMessage, StyledDiscountCode, StyledSmallTextThin, StyledSmsTitle, StyledSmsText } from './MessageStyles';

var _ref = React.createElement('br', null);

var _ref2 = React.createElement(
  StyledSmsText,
  null,
  'Please check your text messages to receive your discount code.'
);

var _ref3 = React.createElement('br', null);

var _ref4 = React.createElement(
  StyledSmallTextThin,
  null,
  'Use the code'
);

var _ref5 = React.createElement('br', null);

var _ref6 = React.createElement(
  StyledSmallText,
  null,
  '(Btw, we already added it to your cart ',
  React.createElement('br', null),
  ' for stress-free shopping!)'
);

var SuccessMessage = React.forwardRef(function (props, ref) {
  return React.createElement(
    StyledSuccessMessage,
    {
      className: 'data-capture-modal__success-message',
      ref: ref
    },
    props.isSmsSubmission ? React.createElement(
      Fragment,
      null,
      React.createElement(
        StyledSmsTitle,
        null,
        'You\'re in!',
        _ref,
        'Thanks for signing up.'
      ),
      _ref2
    ) : React.createElement(
      Fragment,
      null,
      React.createElement(
        StyledSmallText,
        null,
        'You\'re in! Thanks for signing up,'
      ),
      _ref3,
      _ref4,
      React.createElement(
        StyledDiscountCode,
        null,
        props.formDiscount.code
      ),
      React.createElement(
        StyledSmallTextThin,
        null,
        'for ' + props.formDiscount.discountOff + ' off your first order.'
      ),
      _ref5,
      _ref6
    )
  );
});

SuccessMessage.displayName = 'SuccessMessage';

SuccessMessage.propTypes = {
  formDiscount: PropTypes.object,
  isSmsSubmission: PropTypes.bool
};

export default SuccessMessage;